var global = require('../internals/global');
var isCallable = require('../internals/is-callable');
var inspectSource = require('../internals/inspect-source');

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/native-weak-map.js
// module id = 264
// module chunks = 0 1